@if (data.showCloseButton) {
  <div class="fz-dialog__close">
    <button mat-icon-button class="close" (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
<div class="{{ data.customClass }}">
  <mat-dialog-content>
    @if (data.modalType !== 'warning' && data.modalType !== 'error') {
      <div class="modal-alert__dialog-content">
        <div
          class="alert-container bottom-spacer"
          [class.noMargin]="data.noMargin"
        >
          <img class="alert-image" [src]="data.image" alt="" />
        </div>
        @if (data.title && !data.hideTitle) {
          <p
            class="title mat-headline-small pb--1"
            [ngClass]="{ left: data.textAlign === 'left' }"
            [innerHtml]="data.title"
          ></p>
        }
        @if (data.description) {
          <p
            class="description mat-body-large"
            [ngClass]="{ left: data.textAlign === 'left' }"
            [innerHtml]="data.description"
          ></p>
        }
        @if (data.details === true) {
          <a class="details bottom-spacer" [href]="this.url" target="_blank"
            >More details</a
          >
        }
      </div>
    }
    @if (data.modalType === 'warning' || data.modalType === 'error') {
      <div
        class="warning-content"
        [ngClass]="{ left: data.textAlign === 'left' }"
      >
        <div><img src="/shared/svg/{{ data.modalType }}-icon.svg" /></div>
        <div>
          @if (data.title) {
            <p class="title mat-headline" [innerHtml]="data.title"></p>
          }
          @if (data.description) {
            <p
              class="description"
              [ngClass]="{ left: data.textAlign === 'left' }"
              [innerHtml]="data.description"
            ></p>
          }
        </div>
      </div>
    }
  </mat-dialog-content>
  @if (data.hideActions !== true) {
    <mat-dialog-actions
      [class]="{
        'required-action': animateRequiredClass
      }"
    >
      <div class="buttons-container">
        @if (data.primaryActionText) {
          <button
            mat-flat-button
            color="primary"
            cdkFocusInitial
            (click)="onPrimaryClick()"
          >
            {{ data.primaryActionText }}
          </button>
        }
        @if (data.openZenDeskText) {
          @if (data.openZenDeskButtonType === 'flat') {
            <button
              mat-flat-button
              color="primary"
              class="mat-mdc-flat-button"
              fzOpenZenDesk
              (click)="closeModal()"
            >
              {{ data.openZenDeskText }}
            </button>
          } @else {
            <button
              mat-stroked-button
              color="primary"
              fzOpenZenDesk
              (click)="closeModal()"
            >
              {{ data.openZenDeskText }}
            </button>
          }
        }
        @if (data.secondaryActionText) {
          <button
            mat-stroked-button
            color="primary"
            (click)="onSecondaryClick()"
          >
            {{ data.secondaryActionText }}
          </button>
        }
      </div>
      @if (data.showFooterAlert && data.footerAlertText) {
        <div class="footer-alert">
          <p class="footer-alert-text mat-body-large">
            <mat-icon>info</mat-icon>
            <span>{{ data.footerAlertText }}</span>
          </p>
        </div>
      }
    </mat-dialog-actions>
  }

  @if (data.altDescriptionText) {
    <div class="alternative-container mat-dialog-content">
      <div class="modal-separator-container">
        <div class="modal-separator-text-container">
          <p class="modal-separator-text">Or</p>
        </div>
        <div class="modal-separator"></div>
      </div>
      <p class="alternative-text">{{ data.altDescriptionText }}</p>
      <div>
        @if (data.altSecondaryActionText) {
          <button
            mat-stroked-button
            color="primary"
            (click)="onAltSecondaryClick()"
          >
            {{ data.altSecondaryActionText }}
          </button>
        }
      </div>
    </div>
  }
</div>
